import { useEffect, useState } from "react";

const inputStyle = {
    width: '100%', padding: '11px 12px', borderRadius: 10,
    border: '1.5px solid #cbd5e1', marginTop: 4,
    boxSizing: 'border-box', fontSize: 15, background: 'white',
    outline: 'none', color: '#0f172a', textTransform: 'uppercase'
};

const labelStyle = { fontSize: 12, fontWeight: 700, color: '#475569' };

export const CrearUbicacionModal = ({ show, onClose, onSave, maxSedes = 0, sedesRegistradas = 0, sedesDisponibles = 0, limiteAlcanzado = false }) => {

    const [errors, setErrors] = useState({});
    const [form, setForm] = useState({
        ideUbicacion: '',
        codigoUbicacion: '',
        nombreUbicacion: ''
    });

    const resetForm = () => {
        setForm({
            ideUbicacion: '',
            codigoUbicacion: '',
            nombreUbicacion: ''
        });
    };

    useEffect(() => {
        if (!show) {
            resetForm();
            setErrors({});
        }
    }, [show]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value.toUpperCase()
        }));

        setErrors(prev => ({
            ...prev,
            [name]: ''
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!form.codigoUbicacion.trim()) {
            newErrors.codigoUbicacion = 'Debe ingresar el código de la ubicación';
        }

        if (!form.nombreUbicacion.trim()) {
            newErrors.nombreUbicacion = 'Debe ingresar el nombre de la ubicación';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (limiteAlcanzado) return;

        if (!validateForm()) return;

        onSave({ ...form });
    };

    if (!show) return null;

    const pct = limiteAlcanzado
        ? 100
        : maxSedes > 0
            ? Math.round((sedesRegistradas / maxSedes) * 100)
            : 0;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: 20, fontFamily: "'Inter', Arial, sans-serif",
        }}>
            <div style={{
                background: '#ffffff', borderRadius: 24, width: '100%',
                maxWidth: 520, maxHeight: '92vh', overflowY: 'auto',
                boxShadow: '0 25px 60px rgba(0,0,0,0.25)', border: '1px solid #e2e8f0',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)',
                    padding: '22px 26px', color: 'var(--color-primario-contraste)',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    position: 'sticky', top: 0, zIndex: 1,
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                            width: 44, height: 44, borderRadius: 14,
                            background: 'rgba(255,255,255,0.18)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 20,
                        }}>
                            <i className="fa-solid fa-map-location-dot"></i>
                        </div>
                        <div>
                            <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18 }}>Crear Ubicación / Sede</h4>
                            <p style={{ margin: '3px 0 0', opacity: 0.85, fontSize: 12.5 }}>
                                Agrega una nueva sede a tu entidad
                            </p>
                        </div>
                    </div>
                    <button type="button" onClick={onClose} style={{
                        background: 'rgba(255,255,255,0.15)', border: 'none', color: 'var(--color-primario-contraste)',
                        width: 34, height: 34, borderRadius: '50%', fontSize: 16, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}><i className="fa-solid fa-xmark"></i></button>
                </div>

                <form onSubmit={handleSubmit} style={{ padding: 26 }}>
                    {/* Estado del cupo de sedes */}
                    <div style={{
                        background: limiteAlcanzado
                            ? 'linear-gradient(135deg, #fee2e2 0%, #fde8e8 100%)'
                            : 'linear-gradient(135deg, #ecfdf5 0%, #e6f4f2 100%)',
                        border: `1.5px solid ${limiteAlcanzado ? '#fecaca' : '#a7f3d0'}`,
                        borderRadius: 14, padding: '14px 18px', marginBottom: 22,
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                            <span style={{
                                fontSize: 12.5, fontWeight: 800,
                                color: limiteAlcanzado ? '#b91c1c' : '#047857',
                                textTransform: 'uppercase', letterSpacing: 0.6,
                            }}>
                                {limiteAlcanzado ? <><i className="fa-solid fa-ban me-1"></i>Límite alcanzado</> : <><i className="fa-solid fa-building me-1"></i>Cupo de sedes</>}
                            </span>
                            <span style={{
                                fontSize: 13, fontWeight: 800,
                                color: limiteAlcanzado ? '#b91c1c' : '#047857',
                                background: 'rgba(255,255,255,0.6)', padding: '3px 12px',
                                borderRadius: 12,
                            }}>
                                {sedesDisponibles} disponibles
                            </span>
                        </div>
                        <div style={{
                            height: 8, borderRadius: 999, background: 'rgba(255,255,255,0.7)', overflow: 'hidden',
                        }}>
                            <div style={{
                                height: '100%', borderRadius: 999,
                                width: `${pct}%`,
                                background: limiteAlcanzado ? '#ef4444' : 'linear-gradient(90deg,#10b981,var(--color-primario))',
                                transition: 'width .3s ease',
                            }} />
                        </div>
                    </div>

                    <div style={{ marginBottom: 18 }}>
                        <label style={labelStyle}>Código Ubicación / Sede</label>
                        <input
                            name="codigoUbicacion"
                            value={form.codigoUbicacion}
                            onChange={handleChange}
                            placeholder="Ej: Caja 1"
                            maxLength={45}
                            autoFocus
                            style={{
                                ...inputStyle,
                                borderColor: errors.codigoUbicacion ? '#ef4444' : '#cbd5e1',
                            }}
                        />
                        {errors.codigoUbicacion && (
                            <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                {errors.codigoUbicacion}
                            </div>
                        )}
                    </div>

                    <div style={{ marginBottom: 8 }}>
                        <label style={labelStyle}>Nombre Ubicación / Sede</label>
                        <input
                            name="nombreUbicacion"
                            value={form.nombreUbicacion}
                            onChange={handleChange}
                            placeholder="Ej: Sede Principal"
                            maxLength={45}
                            style={{
                                ...inputStyle,
                                borderColor: errors.nombreUbicacion ? '#ef4444' : '#cbd5e1',
                            }}
                        />
                        {errors.nombreUbicacion && (
                            <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                {errors.nombreUbicacion}
                            </div>
                        )}
                    </div>

                    {/* Botones */}
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 26 }}>
                        <button type="button" onClick={onClose} style={{
                            padding: '12px 22px', borderRadius: 12, border: '1.5px solid #cbd5e1',
                            background: 'white', color: '#475569', fontWeight: 700, cursor: 'pointer', fontSize: 14,
                        }}>
                            Cancelar
                        </button>
                        <button type="submit" disabled={limiteAlcanzado} style={{
                            padding: '12px 28px', borderRadius: 12, border: 'none',
                            background: limiteAlcanzado ? '#94a3b8' : 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                            color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: limiteAlcanzado ? 'not-allowed' : 'pointer', fontSize: 14,
                            boxShadow: limiteAlcanzado ? 'none' : '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                            display: 'inline-flex', alignItems: 'center', gap: 8,
                        }}>
                            <i className="fa-solid fa-check"></i> Crear Sede
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};